// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.storage.notification.featurelaunch.enums.RentalManagerFeatureLaunchNotificationPage

export enum RentalManagerFeatureLaunchNotificationPage {
  LISTINGS = 'LISTINGS',
  PROPERTIES = 'PROPERTIES',
}

export const RentalManagerFeatureLaunchNotificationPage_values = [
  RentalManagerFeatureLaunchNotificationPage.LISTINGS,
  RentalManagerFeatureLaunchNotificationPage.PROPERTIES,
] as const;
